import "ddc";
class N {
}
var _ = /* @__PURE__ */ ((I) => (I.RUNNING = "Running", I.SUCCESS = "Success", I.FAILED = "Failed", I))(_ || {}), A = /* @__PURE__ */ ((I) => (I.INCOMPATIBLE_MATCHING_ID_FORMAT = "INCOMPATIBLE_MATCHING_ID_FORMAT", I.INCOMPATIBLE_MATCHING_ID_HASHING_ALGORITHM = "INCOMPATIBLE_MATCHING_ID_HASHING_ALGORITHM", I.MISSING_MATCHING_DATA = "MISSING_MATCHING_DATA", I.MISSING_DATA_FOR_LOOKALIKE = "MISSING_DATA_FOR_LOOKALIKE", I.MISSING_DATA_FOR_INSIGHTS = "MISSING_DATA_FOR_INSIGHTS", I))(A || {});
const S = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CompatibilityErrorCode: A,
  ComputeNodeConfigDecoder: N,
  JobStatus: _
}, Symbol.toStringTag, { value: "Module" }));
export {
  N as C,
  _ as J,
  A as a,
  S as t
};
//# sourceMappingURL=types-CMDdNX_5.js.map
